module.exports = __webpack_public_path__ + "static/media/11NEPAD7.4020e492.jpg";